import React, { useState, useEffect } from 'react';
import { APPCOOKIE } from 'utils/defaults';
import AuthContext from './authcontext';
import { APPADMINCOOKIE } from 'utils/defaults';


const AuthProvider = ({ children, admin = undefined }) => {

  const [isAuthenticated, setIsAuthenticated] = useState(false); // Initial state
  const [isLoaded, setIsLoaded] = useState(false);
  const [wt, setWT] = useState({});

  useEffect(() => {
    const checkToken = async () => {
      const tokenString = localStorage.getItem( admin ? APPADMINCOOKIE : APPCOOKIE );
      const userToken = JSON.parse(tokenString);
      if(userToken && userToken.wt) {
        setIsAuthenticated(true);
        setWT({wt: userToken.wt, dt: userToken.dt, p:userToken.p, a: userToken.a ? userToken.a : 0});
      }
      setIsLoaded(true);
    };
    checkToken();
  }, []);

  // Add functions for login, logout, etc. using AsyncStorageSecure or other storage

  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated, isLoaded, setIsLoaded, wt, setWT /* other functions */ }}>
      {/* {children} */}
      {isLoaded ? children : null}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuth = () => React.useContext(AuthContext);
